@if ((badgesReceived && badgesReceived.length > 0) || (badges && badges.length > 0)) {
<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title class="title-with-icon"><mat-icon>military_tech</mat-icon> Badges</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-chip-set>
      @for (b of badgesReceived; track b) {
      <mat-chip id="badge" #badgeChip class="badge-chip" [ngStyle]="{
      'background-color':b.badge.bgColor ? b.badge.bgColor : 'transparent',
      'border-color': b.badge.borderColor
    }" matTooltip="{{ b.badge.description }}" [removable]="(canDelete('PostBadges') | async)"
        (removed)="deleteBadge(b.badge)">

        <mat-icon [style.color]="b.badge.textColor" matChipAvatar>
          {{ b.badge.icon }}
        </mat-icon>
        <span [style.color]="b.badge.textColor">{{ b.badge.name }}</span>

        @if (canDelete('PostBadges') | async) {
        <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip>
      }
    </mat-chip-set>
    @if (badgesReceived.length == 0) {
        <div class="alert alert-warning">
          <p>
            @if (this.member.memberID == this.userMemberID) {
              Je hebt nog geen badges!
            }
            @else {
              {{this.member.firstName}} heeft nog geen badges!
            }
          </p>
        </div>
    }
    @if (canDelete('PostBadges') | async) {
    @if (badges && badges.length > 0) {
    <div class="grant-section" style="margin-top: 16px; display: flex; align-items: center; gap: 10px;">
      <mat-form-field>
        <mat-label>Geef een Badge</mat-label>
        <mat-select id="badge-select" name="badge" [formControl]="giveBadgeControl">
          @for (badge of badges; track badge) {
          <mat-option [value]="badge.badgeID" [disabled]="doesContainBadge(badge, badgesReceived)">
            {{ badge.name }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="grantBadge()" [disabled]="!giveBadgeControl.valid">
        Geef badge
      </button>
    </div>
    }
    }
  </mat-card-content>
</mat-card>
}

<ng-template #badgeDialog let-data>
  <h4 mat-dialog-title> <mat-icon style="vertical-align: middle;">{{data.badge.icon}}</mat-icon>&nbsp;
    {{data.badge.name}}</h4>
  <mat-dialog-content>
    {{data.badge.description}}
    <br><br>
    @if (data.remark) {
    <small>Opmerking: {{data.remark}} <br></small>
    }
    <small>Badge uitereikt op {{data.date | date:'longDate'}}</small>
    <div align="end">
      <button mat-raised-button color="primary" (click)="dialogRef.close()">
        OK
      </button>
    </div>
  </mat-dialog-content>
</ng-template>